<template>
  <v-snackbar
    v-model="toastStore.show"
    :timeout="toastStore.timeout"
    :color="toastStore.color"
    :location="location"
    min-height="60"
    class="ms-5"
  >
    {{ $t(toastStore.message) }}
  </v-snackbar>
</template>

<script setup lang="ts">
import { useToastStore } from "~/stores/toast";
const toastStore = useToastStore();

defineProps({
  location: String,
});
</script>
